import React from "react";
import useTranslate from "../../core/languages/hooks/useTranslate";
import InputField from "../../ui/components/InputField/InputField";

export enum TransferVehicleEnum {
    SEDAN = 0,
    VAN = 1,
    BUSINESS_SEDAN = 2,
    BUSINESS_VAN = 3,
}

/**
 * Vehicle options for the selector
 * Translations are obtained from the useTranslate hook
 */
export const getSupplierVehicleChoices = (t: (key: string) => string) => [
    { id: TransferVehicleEnum.SEDAN, label: t("common.enum.transferVehicle.sedan"), name: "sedan" },
    { id: TransferVehicleEnum.VAN, label: t("common.enum.transferVehicle.van"), name: "van" },
    { id: TransferVehicleEnum.BUSINESS_SEDAN, label: t("common.enum.transferVehicle.businessSedan"), name: "businessSedan" },
    { id: TransferVehicleEnum.BUSINESS_VAN, label: t("common.enum.transferVehicle.businessVan"), name: "businessVan" },
];

interface SupplierVehicleSelectProps {
    value?: number | string;
    onChange?: (value: number | string) => void;
    disabled?: boolean;
    required?: boolean;
    error?: string;
    label?: string;
}

/**
 * Select component to choose vehicle (Pure React)
 */
export const SupplierVehicleSelect: React.FC<SupplierVehicleSelectProps> = ({
    value,
    onChange,
    disabled = false,
    required = false,
    error,
    label,
}) => {
    const t = useTranslate();
    const choices = getSupplierVehicleChoices(t);

    return (
        <InputField
            type="select"
            value={value || ""}
            onChange={(e) => onChange?.(e.target.value ? Number(e.target.value) : "")}
            disabled={disabled}
            required={required}
            error={error}
            label={label || "Vehicle"}
        >
            <option value="">Select a vehicle</option>
            {choices.map((choice) => (
                <option key={choice.id} value={choice.id}>
                    {choice.label}
                </option>
            ))}
        </InputField>
    );
};
